// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentType } from './environmentTypes';

function getAppUrl(defaultUrl: string): string {
  const params = new URLSearchParams(window.location.search);
  const redirectUri = params.get('redirect_uri') || '';
  try {
    const origin = new URL(redirectUri).origin;
    console.log('origin', origin);
    return origin ? origin : defaultUrl;
  } catch {
    return defaultUrl;
  }
}

export const environment: EnvironmentType = {
  production: false,
  baseUri: 'https://login.doctor-health.jv-it.com.vn',
  domain: 'dev-ntss1gwpoh5kpex5.us.auth0.com', // your auth0 domain
  audience: 'doctor-station-api-identifier', // your auth0 audience
  tmpClientId: 'Yfm7YoGgHXTgnATPlKUHsTTqPL0lcHeB',
  sessionStorageKey: 'queryParams',
  apps: {
    Yfm7YoGgHXTgnATPlKUHsTTqPL0lcHeB: {
      get appUrl() {
        return getAppUrl('https://operator.doctor-health.jv-it.com.vn');
      },
      customDomainConfig: {
          get baseUrl() {
          return getAppUrl('https://operator.doctor-health.jv-it.com.vn');
          },
      },
      faviconUrl: '...',
      privacyUrl: '',
      termUrl: '',
      type: 'healthpicks-operator',
      connection:'DST-HEALTHPICKS'
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
